// extracted by mini-css-extract-plugin
export default {"media":"CC30gmpr","mobile":"mobile","btnLink":"rU7wBSPy","btnWrapper":"wYD9orvO"};